import { createFileRoute, redirect } from '@tanstack/react-router';
import { DEFAULT_DOC_ID, DEFAULT_SECTION_SLUG } from '@/domains/docs/constants';

// Ruta PÚBLICA (sin auth, fuera de _backoffice): la documentación se comparte por link con terceros.
export const Route = createFileRoute('/docs/')({
    beforeLoad: () => {
        throw redirect({
            to: '/docs/$docId/$sectionId',
            params: { docId: DEFAULT_DOC_ID, sectionId: DEFAULT_SECTION_SLUG },
        });
    },
});
